import { render, staticRenderFns } from "./btn.vue?vue&type=template&id=939d272c"
import script from "./btn.vue?vue&type=script&lang=js"
export * from "./btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports